<div class="modal-header">
  <h4 class="modal-title pull-left">Itens selecionados para levar para a reunião</h4>
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="onCloseModal()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<section class="modal-body">
  <ul class="ps-0">
    <ng-container *ngFor="let item of getFormArray(['items'])?.controls; let i = index">
      <ng-container *ngIf="itensData?.items[i] as currentItem">
        <li class="box-title" *ngIf="item.get('checkeds').value == true">
          <div class="head-title">
            <b>{{currentItem.agency?.str_sigla}} - {{currentItem?.agency?.str_nome}}</b>
          </div>
          <ul class="box-title body-title" *ngIf="hasAnyChecked(item,'acPf')">
            <ng-container *ngFor="let com of getFormArray(['items','acPf'],[i])?.controls; let i_pf = index">
              <ng-container   *ngIf="com.getRawValue().checkeds == true">
                <li class="box-title" *ngIf="currentItem['acPf'][i_pf] as variable">
                  <div class="head-subtitle">
                    <span class="dot-letter-1" title="Projeto">P</span>
                    <span>{{variable?.year}}.{{variable?.code}}  -  {{variable?.title}}</span>
                  </div>
                  <ul class="body-subtitle">
                    <ng-container *ngFor="let com2 of getFormArray(['items','acPf','pfIndicators'],[i,i_pf])?.controls; let i_pf_i = index">
                      <ng-container   *ngIf="com2.getRawValue().checkeds == true">
                        <li class="box-title" *ngIf="variable['pfIndicators'][i_pf_i] as variable2">
                          <div class="head-subtitle">
                            <span class="dot-letter-2" title="Indicador">I</span>
                            <span>{{variable2.code}}  -  {{variable2.title}}</span>
                          </div>
                          <ul class="body-subtitle">
                            <ng-container *ngFor="let com3 of getFormArray(['items','acPf','pfIndicators','pf_ind_critical'],[i,i_pf,i_pf_i])?.controls; let i_pf_i_c = index">
                              <ng-container   *ngIf="com3.getRawValue().checkeds == true">
                                <li class="box-title" *ngIf="variable2['pf_ind_critical'][i_pf_i_c] as variable3">
                                  <div class="head-subtitle">
                                    <span class="dot-letter-3" title="Ponto Crítico">C</span>
                                    <span class="width-fit">{{variable3.description}}</span>
                                  </div>
                                  <ul class="body-subtitle">
                                    <ng-container *ngFor="let com4 of getFormArray(['items','acPf','pfIndicators','criticals','actions'],[i,i_pf,i_pf_i,i_pf_i_c])?.controls; let i_pf_i_c_a = index">
                                      <ng-container   *ngIf="com4.getRawValue().checkeds == true">
                                        <li class="box-title" *ngIf="variable3['actions'][i_pf_i_c_a] as variable4">
                                          <div class="head-subtitle">
                                            <span class="dot-letter-4" title="Plano de Ação">A</span>
                                            <span>{{variable4.title}}</span>
                                          </div>
                                        </li>
                                      </ng-container>
                                    </ng-container>
                                  </ul>
                                </li>
                              </ng-container>
                            </ng-container>
                          </ul>
                        </li>
                      </ng-container>
                    </ng-container>
                  </ul>
                </li>
              </ng-container>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ng-container> 
  </ul>
</section>